import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';
import { updateUprightPosition } from '../../../helper/scene';
import { IN_TO_M } from '../../../constants';

export default class UprightPosition extends PureComponent {
  onChange = (ev, { value }) => {
    const {
      actions,
      attributeName,
      configuration,
      claraApi,
      appApi,
      setAppState,
      getAppState,
      models,
    } = this.props;
    if (configuration[attributeName].value === value) return;
    const { modelId, blocks } = configuration.uprights;

    const frontBlock = blocks.uprightFront;
    const rowDiff = value - configuration[attributeName].value;
    let newAppState = getAppState();
    rowDiff > 0
      ? frontBlock.addRows(Array(rowDiff).fill(1 * IN_TO_M))
      : frontBlock.deleteRows(-rowDiff, updatedModels => {
          updatedModels.forEach(model => {
            if (model.valid) return;
            newAppState = actions.removeModel(model.modelId, newAppState);
            const { attribute, value } = models[model.modelId];
            newAppState = actions.setConfiguration(
              {
                attribute,
                value,
                change: model.modelId,
              },
              newAppState
            );
          });
        });

    newAppState = actions.setConfiguration(
      {
        attribute: attributeName,
        value: { value },
      },
      newAppState
    );
    updateUprightPosition(claraApi, newAppState);
    appApi.model.updateBlocks(modelId, blocks);
    setAppState(newAppState);
  };

  render() {
    return <Dropdown {...this.props} onChange={this.onChange} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/UprightPosition.js